import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useUI } from "@/context/UIContext";
import { products } from "@/mocks/products";

export default function SearchOverlay() {
  const { searchOpen, closeSearch } = useUI();
  const [q, setQ] = useState("");
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (searchOpen) {
      setMounted(true);
      const t = requestAnimationFrame(() => setVisible(true));
      return () => cancelAnimationFrame(t);
    } else {
      setVisible(false);
      const t = setTimeout(() => setMounted(false), 260);
      return () => clearTimeout(t);
    }
  }, [searchOpen]);

  const results = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return products.slice(0, 6);
    return products.filter(
      (p) => p.name.toLowerCase().includes(s) || p.category.toLowerCase().includes(s) || p.material.toLowerCase().includes(s)
    );
  }, [q]);

  if (!mounted) return null;

  return (
    <div
      className="fixed inset-0 z-[80] bg-canvas flex flex-col transition-opacity"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(8px)",
        transition: "opacity 260ms cubic-bezier(0.22,1,0.36,1), transform 260ms cubic-bezier(0.22,1,0.36,1)",
      }}
    >
      <div className="shell flex items-center gap-4 h-[84px] border-b border-stone">
        <i className="ri-search-line text-[18px] text-graphite"></i>
        <input
          autoFocus
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search jewelry"
          className="flex-1 bg-transparent outline-none text-2xl font-display placeholder:text-graphite"
        />
        <button onClick={closeSearch} aria-label="Close" className="w-10 h-10 -mr-2 flex items-center justify-center cursor-pointer transition-opacity hover:opacity-65">
          <i className="ri-close-line text-[18px]"></i>
        </button>
      </div>
      <div className="flex-1 overflow-y-auto">
        <div className="shell py-16">
          <p className="eyebrow mb-8">{q ? `Results (${results.length})` : "Suggested"}</p>
          {results.length === 0 && <p className="text-graphite text-sm py-24 text-center">No pieces found.</p>}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
            {results.map((p) => (
              <Link to={`/product/${p.slug}`} onClick={closeSearch} key={p.id} className="block cursor-pointer group">
                <div className="w-full aspect-square bg-stone overflow-hidden">
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover object-top group-hover:opacity-90 transition-opacity" />
                </div>
                <p className="mt-4 text-[15px] text-black transition-colors group-hover:text-[#1E144D]">{p.name}</p>
                <p className="mt-[6px] text-[13px] text-graphite">${p.price.toLocaleString()}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}